import axios from 'axios';
import { configApiInstance } from './config';

/**
 * An axios client with NO interceptors — deliberately, and permanently.
 *
 * Two auth calls must never re-enter the main client's response interceptor:
 *
 * - the token refresh, because a 401 on the refresh itself would trigger another
 *   refresh and recurse;
 * - logout, because a 401 there would trigger a refresh for a user who is
 *   already on their way out.
 *
 * Do not add an interceptor to this instance "for consistency", and do not route
 * ordinary requests through it: it performs no error normalisation, so its
 * rejections are raw axios errors rather than the app's TCustomAxiosError shape.
 */
export const bareApi = axios.create(configApiInstance);
